import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { m as mimetypeToExtension, a as mimetypes } from './mimetypes-e076bdb8.js';
import { i as inputFileTypes, a as inputFileTypemap, v as vFile } from './types-54e7e023.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { S as vOneOf, m as vFilename, d as vOneOfI, M as vMaxNumber, b as vMinLength, a1 as vUndefOr, a as vString, Q as vBoolean, W as vArrayOf, O as vInteger, K as vMinNumber, Z as vObjectWith, $ as vNullOr } from './validation-02b8d01d.js';
import { w as waitNextRender, r as resolveNextRender } from './browser-202fc7f4.js';
import { c as currentLocale, t } from './i18n-939e2dee.js';

const dsInputFileCss = "ds-input-file:not([is-without-styling]),ds-input-file-multiple:not([is-without-styling]){display:block;position:relative}ds-input-file:not([is-without-styling]) .container,ds-input-file-multiple:not([is-without-styling]) .container{cursor:pointer;border-width:2px;border-style:dashed;border-radius:var(--radius);border-color:var(--grey-600);background-color:white;padding:calc(var(--gw) * 1.2) calc(var(--gw) * 2) calc(var(--gw) * 1.5);margin-bottom:0.25rem !important;text-align:center}ds-input-file:not([is-without-styling]) .container ds-button[mode='text'] ds-icon svg,ds-input-file-multiple:not([is-without-styling]) .container ds-button[mode='text'] ds-icon svg{fill:var(--primary)}ds-input-file:not([is-without-styling]) .container>input,ds-input-file-multiple:not([is-without-styling]) .container>input{position:absolute;width:100%;height:100%;z-index:-1;top:0;left:0;border:1px transparent;box-shadow:none;opacity:0}ds-input-file:not([is-without-styling]) .container .value,ds-input-file-multiple:not([is-without-styling]) .container .value{display:block}ds-input-file:not([is-without-styling]) .container label,ds-input-file-multiple:not([is-without-styling]) .container label{display:block;position:absolute;margin-bottom:0.25rem !important;color:#414852;font-size:0.88888889rem;line-height:1.56rem;z-index:2;left:0;top:0;background-color:white;padding:0 calc(var(--gw) * 0.5);line-height:1.25;pointer-events:none;transform:translateY(-7px) translateX(12px) scale(0.8) !important}ds-input-file:not([is-without-styling]) .container .help-info,ds-input-file-multiple:not([is-without-styling]) .container .help-info,ds-input-file:not([is-without-styling]) .container .help-error,ds-input-file-multiple:not([is-without-styling]) .container .help-error,ds-input-file:not([is-without-styling]) .container .help-info-title,ds-input-file-multiple:not([is-without-styling]) .container .help-info-title{padding:0;line-height:1;width:100%;font-size:0.79012346rem;line-height:1.3rem;color:var(--grey-800)}ds-input-file:not([is-without-styling]) .container .help-info-title,ds-input-file-multiple:not([is-without-styling]) .container .help-info-title{font-weight:500;margin-top:calc(var(--gw) * 0.2);color:var(--grey-900)}ds-input-file:not([is-without-styling]) .file-list,ds-input-file-multiple:not([is-without-styling]) .file-list{color:var(--grey-800);margin:var(--gw) 0 calc(var(--gw) / 4) 0;font-size:0.88888889rem;line-height:1.56rem}ds-input-file:not([is-without-styling]) .file-list .value,ds-input-file-multiple:not([is-without-styling]) .file-list .value{line-height:1;margin:calc(var(--gw) / 2) 0 0 0;border-radius:var(--radius);border:1px solid var(--grey-500);padding:calc(var(--gw) / 2) calc(var(--gw) * 0.8);color:var(--black);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}ds-input-file:not([is-without-styling]) .file-list .value ds-icon.attachment,ds-input-file-multiple:not([is-without-styling]) .file-list .value ds-icon.attachment,ds-input-file:not([is-without-styling]) .file-list .value ds-spinner,ds-input-file-multiple:not([is-without-styling]) .file-list .value ds-spinner{margin-right:0.8rem;width:1rem}ds-input-file:not([is-without-styling]) .file-list .value ds-icon.attachment,ds-input-file-multiple:not([is-without-styling]) .file-list .value ds-icon.attachment{color:var(--grey-900)}ds-input-file:not([is-without-styling]) .file-list .value .value-container,ds-input-file-multiple:not([is-without-styling]) .file-list .value .value-container{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:center;align-items:center;width:100%}ds-input-file:not([is-without-styling]) .file-list .value .value-container .value-text,ds-input-file-multiple:not([is-without-styling]) .file-list .value .value-container .value-text{font-size:0.88888889rem;line-height:1.56rem;word-break:break-word}ds-input-file:not([is-without-styling]) .file-list .value .value-container ds-icon.clear,ds-input-file-multiple:not([is-without-styling]) .file-list .value .value-container ds-icon.clear{cursor:pointer}ds-input-file:not([is-without-styling]) .file-list .value .value-container ds-progress,ds-input-file-multiple:not([is-without-styling]) .file-list .value .value-container ds-progress{margin-top:0.25rem !important;width:33%;margin:0}ds-input-file:not([is-without-styling]) .file-list .value.error,ds-input-file-multiple:not([is-without-styling]) .file-list .value.error{border-color:var(--red-500) !important}ds-input-file:not([is-without-styling]).error .container,ds-input-file-multiple:not([is-without-styling]).error .container{border-color:var(--red-500) !important}ds-input-file:not([is-without-styling]).error .container label,ds-input-file-multiple:not([is-without-styling]).error .container label,ds-input-file:not([is-without-styling]).error .container .help-error,ds-input-file-multiple:not([is-without-styling]).error .container .help-error{color:var(--red-500) !important}ds-input-file:not([is-without-styling])[is-being-dropped],ds-input-file-multiple:not([is-without-styling])[is-being-dropped]{cursor:grabbing}ds-input-file:not([is-without-styling])[is-being-dropped] .container,ds-input-file-multiple:not([is-without-styling])[is-being-dropped] .container{background-color:var(--grey-500)}ds-input-file:not([is-without-styling])[is-disabled] .file-list ds-icon.clear,ds-input-file-multiple:not([is-without-styling])[is-disabled] .file-list ds-icon.clear,ds-input-file:not([is-without-styling])[is-readonly] .file-list ds-icon.clear,ds-input-file-multiple:not([is-without-styling])[is-readonly] .file-list ds-icon.clear,ds-input-file:not([is-without-styling])[is-uploading] .file-list ds-icon.clear,ds-input-file-multiple:not([is-without-styling])[is-uploading] .file-list ds-icon.clear{display:none}ds-input-file:not([is-without-styling])[is-disabled] .container,ds-input-file-multiple:not([is-without-styling])[is-disabled] .container,ds-input-file:not([is-without-styling])[is-readonly] .container,ds-input-file-multiple:not([is-without-styling])[is-readonly] .container,ds-input-file:not([is-without-styling])[is-uploading] .container,ds-input-file-multiple:not([is-without-styling])[is-uploading] .container{cursor:no-drop}ds-input-file:not([is-without-styling]) ds-button button,ds-input-file-multiple:not([is-without-styling]) ds-button button,ds-input-file:not([is-without-styling]) ds-button button:hover,ds-input-file-multiple:not([is-without-styling]) ds-button button:hover{background:transparent !important}ds-input-file:not([is-without-styling]) ds-progress,ds-input-file-multiple:not([is-without-styling]) ds-progress{display:block;height:0.375rem;margin-top:calc(var(--gw) * 1.25);margin-bottom:calc(var(--gw) * 1.25)}";

const DsInputFileMultiple = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.dsInput = createEvent(this, "dsInput", 7);
    this.upload = createEvent(this, "upload", 7);
    this.uploadError = createEvent(this, "uploadError", 7);
    this.delete = createEvent(this, "delete", 7);
    this.validMimeTypes = [];
    this.validExtensions = [];
    this.nextRenderPromises = [];
    this.fileErrors = [];
    this.displayError = false;
    this.validationError = undefined;
    this.injectedError = undefined;
    this.propError = {};
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.helperTextTitle = undefined;
    this.helperText = undefined;
    this.isDisabled = false;
    this.isReadonly = false;
    this.isWithoutStyling = false;
    this.isRequired = false;
    this.mimetype = undefined;
    this.maxsize = undefined;
    this.value = [];
    this.isClearable = true;
    this.label = 'Uploaded files';
    this.isBeingDropped = false;
  }
  // istanbul ignore next
  updateLocale() {
    this.currentLocale = currentLocale();
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vMinLength(1)))
      return;
  }
  watchHelperTextTitle() {
    /* istanbul ignore if */
    if (!propCheck(this, 'helperTextTitle', 'string', vUndefOr(vString)))
      return;
  }
  watchHelperText() {
    /* istanbul ignore if */
    if (!propCheck(this, 'helperText', 'string', vUndefOr(vString)))
      return;
  }
  async watchIsDisabled() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isDisabled', 'boolean', vBoolean))
      return;
    if (this.isDisabled)
      this.clear();
    await waitNextRender(this);
    this.runValidation(this.isDisabled ? [] : this.value);
  }
  async watchIsReadonly() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isReadonly', 'boolean', vBoolean))
      return;
    await waitNextRender(this);
    this.runValidation(this.value);
  }
  watchIsWithoutStyling() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isWithoutStyling', 'boolean', vBoolean))
      return;
  }
  watchIsRequired() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isRequired', 'boolean', vBoolean))
      return;
    this.runValidation(this.value);
  }
  watchMimetype() {
    /* istanbul ignore if */
    if (!propCheck(this, 'mimetype', inputFileTypes.join(' | ') + ' | Mimetype[]', vUndefOr(v => vOneOf(inputFileTypes)(v) &&
      vArrayOf(vOneOf(mimetypes))(v))))
      return;
    if (Array.isArray(this.mimetype))
      this.validMimeTypes = this.mimetype;
    else if (this.mimetype)
      this.validMimeTypes = inputFileTypemap[this.mimetype];
    else
      this.validMimeTypes = [];
    this.validExtensions = this.validMimeTypes.reduce((acc, mimetype) => [
      ...acc,
      ...mimetypeToExtension[mimetype]
    ], []);
    this.runValidation(this.value);
  }
  watchMaxsize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'maxsize', 'string', vUndefOr(v => vInteger(v) || vMinNumber(1)(v))))
      return;
    this.runValidation(this.value);
  }
  watchValue() {
    /* istanbul ignore if */
    if (!propCheck(this, 'value', 'Array<InputFileMultipleValue | File>', vArrayOf(v => vFile(v) &&
      vObjectWith({
        name: vString,
        size: vUndefOr(vNullOr(vInteger)),
        type: vUndefOr(vNullOr(vString)),
        url: vUndefOr(vNullOr(vString)),
        isUploading: vUndefOr(vBoolean),
        progress: vUndefOr(v => vMinNumber(0)(v) || vMaxNumber(100)(v))
      })(v))))
      return;
    this.injectedError = undefined;
    this.runValidation(this.value);
  }
  watchIsClearable() {
    /* istanbul ignore if */
    if (!propCheck(this, 'isClearable', 'boolean', vBoolean))
      return;
  }
  watchLabel() {
    /* istanbul ignore if */
    if (!propCheck(this, 'label', 'string', vString))
      return;
  }
  runValidation(values) {
    if (!this.inputElement)
      return;
    this.inputElement.setCustomValidity('');
    this.validationError = undefined;
    if (this.isDisabled || this.isReadonly) {
      if (this.dsForm)
        this.dsForm.checkValidity();
      return;
    }
    this.fileErrors = [];
    if (this.isRequired && !values.length) {
      this.validationError = t('file.required');
    }
    for (let value of values) {
      const validationError = this.validateFileValue(value);
      this.fileErrors.push(!!validationError);
      if (!this.validationError && validationError)
        this.validationError = validationError;
    }
    if (this.validationError) {
      this.inputElement.setCustomValidity(this.validationError);
    }
    else if (this.injectedError) {
      this.inputElement.setCustomValidity(this.injectedError);
    }
    if (this.dsForm)
      this.dsForm.checkValidity();
  }
  validateFileValue(value) {
    let extension = '';
    if (value.name && value.name.lastIndexOf('.') !== -1) {
      extension = value.name.substr(value.name.lastIndexOf('.') + 1);
    }
    // sometimes the mimetype is empty string, allow this
    if ((value instanceof File || value.type) && this.validMimeTypes.length && vOneOf(this.validMimeTypes)(value.type)) {
      return t('file.mimetype', { mimetypes: this.mimetype, value: value.type });
    }
    else if (vFilename(value.name)) {
      return t('file.name', { filename: value.name, value: value.name });
    }
    else if (this.validExtensions.length && vOneOfI(this.validExtensions)(extension)) {
      return t('file.extension', { filename: value.name, value: extension, extensions: this.validExtensions.join(', ') });
    }
    else if ((value instanceof File || value.size) && this.maxsize && vMaxNumber(this.maxsize)(value.size)) {
      return t('file.maxsize', { maxsize: this.maxsize, value: value.size });
    }
  }
  bytes(bytes, decimals = 2) {
    const factor = 1024;
    const suffixes = [' bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let currentNumeric = bytes, suffix = 0;
    while (currentNumeric >= factor && suffixes[suffix + 1]) {
      currentNumeric /= factor;
      suffix++;
    }
    currentNumeric *= Math.pow(10, decimals);
    currentNumeric = Math.round(currentNumeric);
    currentNumeric /= Math.pow(10, decimals);
    return currentNumeric + suffixes[suffix];
  }
  captureEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  }
  /* istanbul ignore next */
  handleBodyDrag(e) {
    this.captureEvent(e);
    e.dataTransfer.dropEffect = 'none';
  }
  handleDrop(e) {
    this.captureEvent(e);
    this.isBeingDropped = false;
    if (this.isDisabled || this.isReadonly)
      return;
    this.displayError = true;
    this.addFiles(e.dataTransfer.files);
  }
  async injectError(error) {
    this.injectedError = error;
    this.runValidation(this.value);
    this.inputElement.dispatchEvent(new InputEvent('change', { bubbles: true }));
    this.displayError = true;
  }
  async hideError() {
    this.injectedError = undefined;
    this.runValidation(this.value);
    this.inputElement.dispatchEvent(new InputEvent('change', { bubbles: true }));
    this.displayError = false;
  }
  async clear() {
    if (this.inputElement)
      this.inputElement.value = null;
    this.runValidation([]);
    this.dsInput.emit([]);
    for (let idx = this.value.length - 1; idx >= 0; idx--) {
      this.delete.emit(idx);
    }
    if (this.inputElement)
      this.inputElement.dispatchEvent(new InputEvent('change', { bubbles: true }));
  }
  remove(index) {
    const newValue = [...this.value];
    newValue.splice(index, 1);
    this.dsInput.emit(newValue);
    this.delete.emit(index);
  }
  addFiles(files) {
    const fileArray = Array.from(files);
    this.dsInput.emit([...this.value, ...fileArray]);
    for (let file of fileArray) {
      if (!this.validateFileValue(file))
        this.upload.emit(file);
      else
        this.uploadError.emit(file);
    }
    this.inputElement.value = null; // clear the input value so it doesn't get emitted accidentally
  }
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  componentDidLoad() {
    if (this.inputElement)
      this.dsForm = this.inputElement.closest('ds-form');
    this.runValidation(this.value);
  }
  componentDidRender() {
    resolveNextRender(this);
  }
  disconnectedCallback() {
    if (this.dsForm)
      this.dsForm.checkValidity();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    const error = this.displayError && (this.injectedError || this.validationError);
    let accept = this.mimetype ? this.validMimeTypes.join(',') : '';
    // end user may not know these mime types (office not installed) so append the extension for the search
    if (this.mimetype === 'document')
      accept += ',.doc,.docx';
    return (h(Host, { class: { error: !!error }, "has-value": this.value.length ? true : false, "is-being-dropped": this.isBeingDropped, onDragEnter: (e) => { this.isBeingDropped = true; this.captureEvent(e); }, onDragOver: (e) => {
        this.isBeingDropped = true;
        /* istanbul ignore next */
        if (!this.isDisabled && !this.isReadonly)
          e.dataTransfer.dropEffect = 'copy';
        else
          e.dataTransfer.dropEffect = 'none';
        this.captureEvent(e);
      }, onDragLeave: (e) => { this.isBeingDropped = false; this.captureEvent(e); }, onDrop: (e) => { this.handleDrop(e); } }, h("div", { class: "container", onClick: () => {
        if (!this.isDisabled && !this.isReadonly)
          this.inputElement.click();
      } }, h("ds-button", { type: "button", icon: "upload", iconSize: "1.8rem", mode: "text", version: "monochrome", "aria-label": this.name, isDisabled: this.isDisabled || this.isReadonly }), h("input", { ref: el => this.inputElement = el, name: this.name, id: `ds-input-${this.name}`, type: "file", disabled: this.isDisabled, readonly: this.isReadonly, onInput: e => {
        this.displayError = true;
        const target = e.target;
        this.addFiles(target.files);
      }, onBlur: () => this.displayError = true, onInvalid: () => this.displayError = true, accept: accept, multiple: true }), this.helperTextTitle && h("div", { class: "help-info-title" }, this.helperTextTitle), this.helperText && h("div", { class: "help-info" }, this.helperText), error && h("div", { class: "help-error" }, error)), this.value.length > 0 &&
      h("div", { class: "file-list" }, this.label, this.value.map((value, index) => (h("div", { class: { value: true, error: this.fileErrors[index] } }, !(value instanceof File) && value.isUploading
        ? h("ds-spinner", { size: "1rem" })
        : h("ds-icon", { name: "attachment", color: "var(black)", class: "attachment", size: "1rem" }), h("div", { class: "value-container" }, h("div", { class: "value-text" }, !(value instanceof File) && !value.isUploading && value.url
        ? h("a", { href: value.url, target: "_blank" }, value.name)
        : value.name, "\u00A0", value.size
        ? this.bytes(value.size)
        : ''), !(value instanceof File) && value.isUploading && value.progress
        ? h("ds-progress", { progress: value.progress })
        : '', (this.fileErrors[index] || (this.isClearable && !this.isReadonly && !this.isDisabled)) && (value instanceof File || !value.isUploading)
        ? h("ds-icon", { name: "bin", color: "var(--grey-900)", class: "clear", size: "1.2rem", onClick: () => this.remove(index) })
        : '')))))));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "helperTextTitle": ["watchHelperTextTitle"],
    "helperText": ["watchHelperText"],
    "isDisabled": ["watchIsDisabled"],
    "isReadonly": ["watchIsReadonly"],
    "isWithoutStyling": ["watchIsWithoutStyling"],
    "isRequired": ["watchIsRequired"],
    "mimetype": ["watchMimetype"],
    "maxsize": ["watchMaxsize"],
    "value": ["watchValue"],
    "isClearable": ["watchIsClearable"],
    "label": ["watchLabel"]
  }; }
};
DsInputFileMultiple.style = dsInputFileCss;

export { DsInputFileMultiple as ds_input_file_multiple };
